<template>
  <router-view :class="theme" />
</template>

<script>
export default {
  name: "AppTemplate",
  data() {
    return {
      theme: this.$store.getters.theme ? this.$store.getters.theme : "light",
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    handleKeyDown(event) {
      // Check for Ctrl + Alt + E
      if (event.ctrlKey && event.altKey && event.key.toLowerCase() === "e") {
        this.$router.push("/crawl-manual"); // Navigate to the desired route
      }
    },
  },
};
</script>
